import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import InvoiceManager from '../components/billing/InvoiceManager';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { CurrencyDollarIcon, PlusIcon, ChevronDownIcon, DocumentTextIcon, ClockIcon, ReceiptPercentIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-hot-toast';

const Billing: React.FC = () => {
  const { t } = useLanguage();
  const [showDropdown, setShowDropdown] = useState(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showDropdown) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showDropdown]);

  const handleCreateInvoice = (type: 'INVOICE' | 'PROFORMA') => {
    if ((window as any).triggerCreateInvoice) {
      (window as any).triggerCreateInvoice(type);
    }
    setShowDropdown(false);
  };

  const dropdownButton = (
    <div className="relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowDropdown(!showDropdown);
        }}
        className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-lg hover:bg-white/30 transition-all flex items-center text-sm font-medium"
      >
        <PlusIcon className="h-4 w-4 mr-2" />
        Új bizonylat
        <ChevronDownIcon className="h-4 w-4 ml-2" />
      </button>
      
      {showDropdown && (
        <div 
          className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-600 z-50"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="py-1">
            <button
              onClick={() => handleCreateInvoice('INVOICE')}
              className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center text-sm"
            >
              <DocumentTextIcon className="h-4 w-4 mr-3 text-blue-600" />
              <div>
                <div className="font-medium text-gray-900 dark:text-gray-100">Számla vázlat</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Új számla létrehozása</div>
              </div>
            </button>
            
            <button
              onClick={() => handleCreateInvoice('PROFORMA')}
              className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center text-sm"
            >
              <ClockIcon className="h-4 w-4 mr-3 text-green-600" />
              <div>
                <div className="font-medium text-gray-900 dark:text-gray-100">Díjbekérő vázlat</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Új díjbekérő létrehozása</div>
              </div>
            </button>
            
            <button
              onClick={() => {
                toast('Nyugta funkció hamarosan elérhető', {
                  icon: 'ℹ️',
                });
                setShowDropdown(false);
              }}
              className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center text-sm"
            >
              <ReceiptPercentIcon className="h-4 w-4 mr-3 text-purple-600" />
              <div>
                <div className="font-medium text-gray-900 dark:text-gray-100">Nyugta</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Új nyugta létrehozása</div>
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="space-y-6 pb-20 sm:pb-0">
      <CommonPageHeader
        title={t('nav.billing')}
        subtitle={t('nav.billingSubtitle')}
        icon={CurrencyDollarIcon}
        actionButton={dropdownButton}
      />

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md">
        <InvoiceManager onCreateInvoice={() => {}} />
      </div>
    </div>
  );
};

export default Billing; 